import { createSlice } from "@reduxjs/toolkit";
import { fetchAllDepartment, fetchEmails } from "../thunks/emails";

const emailsSlice = createSlice({
  name: "emails",
  initialState: {
    emails: [],
    users: [],
    departments: [],
  },
  reducers: {
    setEmails: (state, action) => {
      state.emails = action.payload;
    },
    deleteEmail: (state, action) => {
      state.emails = state.emails.filter(email => email.id !== action.payload);
    },
    addEmail: (state, action) => {
      state.emails.push(action.payload);
    },
    setUsers: (state, action) => {
      state.users = action.payload
    },
    setDepartment: (state, action) => {
      state.departments = action.payload;
    },
  },
  extraReducers: (builders) => {
    builders.addCase(fetchEmails.fulfilled, (state, action) => {
      console.log("Emails Payload Received:", action.payload);    
        state.emails = action.payload.emails;
      state.users = action.payload.users;
    })
      .addCase(fetchAllDepartment.fulfilled, (state, action) => {
        state.departments = action.payload;
      })
  }
});

export const { setEmails, deleteEmail,addEmail, setUsers, setDepartment } = emailsSlice.actions;
export default emailsSlice.reducer;
